import styled from 'styled-components';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
